import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { push } from "connected-react-router";
import { Button, ClickAwayListener } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import useWindow from "hooks/useWindow";
import Analytics from "../../../helpers/analytics";
import fetchSearch from "pages/licensing/mvp/services/fetchSearch";

import { setQuerySuggestion, appendToHistory } from "./state/querySuggestion";
import Wrapper from "./styles/Wrapper.style";

function SearchInput(props) {
  const dispatch = useDispatch();
  const { active, query } = useSelector((state) => state.querySuggestion);
  const { header, homepage } = props;
  const [homeActive, setHomeActive] = useState(false);
  const search = useSelector((state) => state.pages.search);
  const { isMobile } = useWindow(550);

  const onSubmit = (e) => {
    e.preventDefault();

    dispatch(appendToHistory(query));
    dispatch(push(`/licensing/search?q=${query}`));
  };

  const clickAway = () => {
    dispatch(
      setQuerySuggestion({
        active: false
      })
    );
  };

  const handleChange = (e) => {
    dispatch(
      setQuerySuggestion({
        query: e.target.value
      })
    );
  };

  const handleClick = (e) => {
    Analytics.track("search_bar_click", {
      category: "LP_search",
      label: "search_bar_allpages"
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && query === "") {
      Analytics.track("null_search", {
        category: "LP_search",
        label: "LP_nullsearch",
        search_type: "Null search",
        search_keyword: "N/A",
        total_number_of_search_results: search.pagination.totalResults
      });
    }
  };

  const handleClickSearchIcon = (e) => {
    if (query === "") {
      Analytics.track("null_search", {
        category: "LP_search",
        label: "LP_nullsearch",
        search_type: "Null search",
        search_keyword: "N/A",
        total_number_of_search_results: search.pagination.totalResults
      });
    }
  };

  useEffect(() => {
    return () => {
      dispatch(
        setQuerySuggestion({
          query: "",
          active: false
        })
      );
    };
  }, []);

  useEffect(() => {
    dispatch(fetchSearch());
  }, []);

  return (
    <Wrapper className={header ? "search__header" : ""}>
      <div className="search__wrapper">
        <div className="search__box--wrapper">
          <div className="search__logo" />
          <div className="search__form--container">
            <ClickAwayListener onClickAway={clickAway}>
              <form onSubmit={onSubmit}>
                <div className="form__fields">
                  <div className="input-wrapper">
                    <input
                      style={{ background: "#ffffff", color: "#939393" }}
                      type="text"
                      placeholder={
                        isMobile
                          ? "AI Powered Search"
                          : "AI Powered Search (try URL or keyword e.g. funny cat)"
                      }
                      value={query}
                      onChange={handleChange}
                      onClick={handleClick}
                      onKeyDown={handleKeyDown}
                    />
                  </div>
                  {header && (
                    <div className="search-button-section" onClick={handleClickSearchIcon}>
                      <Button
                        type="submit"
                        className={classnames("search__submit", { active: active })}
                      >
                        <SearchIcon />
                        {isMobile ? "" : <span className="search-icon-label">Search</span>}
                      </Button>
                    </div>
                  )}
                  {!header && (
                    <Button
                      type="submit"
                      className={classnames("button__submit", { active: active })}
                    >
                      <SearchIcon onClick={handleClickSearchIcon} />
                      {isMobile ? "" : "Search"}
                    </Button>
                  )}
                </div>
              </form>
            </ClickAwayListener>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

SearchInput.propTypes = {
  header: PropTypes.bool
};

SearchInput.defaultProps = {
  header: false
};

export default SearchInput;
